/**
 * PDP external-landing auto-open.
 *
 * When a visitor arrives on a product page from an external source (external referrer or a
 * campaign/ad/email tracking param), open the "Start Shopping" vehicle search popup. It opens on
 * every qualifying landing, even if a vehicle is already selected (an external link may target a
 * different/wrong vehicle) and with no once-per-session suppression.
 *
 * Loaded eagerly + product-gated from snippets/script-tags.liquid. It must NOT be lazy-loaded
 * (data-src): the lazy loader only fires on the first user interaction, so a deferred/lazy script
 * would never auto-open the popup on page load. Dismiss handlers live here (not in the lazy
 * custom.js, whose close handler redirects to the homepage on PDPs).
 */
(function () {
  'use strict';

  // True when the visitor arrived from an external source: a referrer on a different host, or a
  // campaign/ad/email tracking param (these often arrive with an empty referrer).
  function isExternalSource() {
    var params = ['utm_source', 'utm_medium', 'utm_campaign', 'gclid', 'fbclid', 'msclkid'];
    try {
      var search = new URLSearchParams(window.location.search);
      for (var i = 0; i < params.length; i++) {
        if (search.has(params[i])) return true;
      }
    } catch (e) { }

    var ref = document.referrer;
    if (ref) {
      try {
        // Normalize www. and treat subdomains of our host as internal, so www./b2b./etc.
        // transitions are not mistaken for an external visit.
        var refHost = new URL(ref).hostname.replace(/^www\./, '');
        var currentHost = window.location.hostname.replace(/^www\./, '');
        if (refHost && refHost !== currentHost && !refHost.endsWith('.' + currentHost)) return true;
      } catch (e) { }
    }

    return false;
  }

  function closePopup(modal) {
    if (modal) modal.classList.remove('open');
    var overlay = document.querySelector('#site-overlay');
    if (overlay) overlay.classList.remove('overlay--body');
    document.body.classList.remove('scroll-fixed');
    document.body.classList.remove('overflow-hidden');
  }

  // Closing simply hides the popup and keeps the visitor on the page.
  function bindDismiss(container, modal) {
    var closeBtn = container.querySelector('.close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        // stopImmediatePropagation (not just stopPropagation) so that if the lazy custom.js close
        // handler also binds to this same .close element, its homepage redirect never runs.
        e.stopImmediatePropagation();
        closePopup(modal);
      });
    }

    var continueBtn = container.querySelector('.block__model-vehicle-shopping button');
    if (continueBtn) {
      continueBtn.addEventListener('click', function () { closePopup(modal); });
    }

    var overlay = document.querySelector('#site-overlay');
    if (overlay) {
      overlay.addEventListener('click', function () {
        if (modal.classList.contains('open')) closePopup(modal);
      });
    }

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && modal.classList.contains('open')) {
        closePopup(modal);
      }
    });
  }

  function openStartShopping(container, modal) {
    container.querySelectorAll('.modal-body').forEach(function (el) { el.classList.add('d-none'); });
    var startStep = container.querySelector('#find-new-behicle');
    if (startStep) startStep.classList.remove('d-none');

    modal.classList.add('open');
    var overlay = document.querySelector('#site-overlay');
    if (overlay) overlay.classList.add('overlay--body');
    document.body.classList.add('scroll-fixed');
    document.body.classList.add('overflow-hidden');

    bindDismiss(container, modal);
  }

  function init() {
    if (!document.body || !document.body.classList.contains('template-product')) return;

    var container = document.querySelector('.pdp-vehicle-model');
    var modal = container ? container.querySelector('.modal') : null;
    if (!container || !modal) return;

    if (!isExternalSource()) return;

    openStartShopping(container, modal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
